import { alpha } from '@mui/material/styles';

import { buttonStyles } from './ButtonStyles';
import { color, radius } from '../../theme/tokens';

// Radius reads from the token module. The values here were already the brief's
// locked three, so this is a source change rather than a visual one — it stops
// the next edit drifting off the lock.
//
// Colour followed in Phase Sweep batch 7 (STACK-509): the olive title and focus
// rings, the blue-grey field fills and the destructive tints are all tokens
// now. The two destructive tints were already `color.destructive` written in
// decimal rgba, so that pair is value-preserving (DESIGN_DOC §10).
export const authStyles = {
  // Container and Paper styles
  paper: {
    padding: 4,
    marginTop: 8,
    borderRadius: radius.lg,
    background: color.paper,
    boxShadow: '0 0.125rem 0.75rem rgba(0,0,0,0.08)'
  },
  
  // Typography
  title: {
    color: color.evergreen,
    fontWeight: 700,
    mb: 3
  },

  // Form Elements
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: radius.md,
      backgroundColor: color.surface,
      '&:hover': {
        backgroundColor: color.mintSoft,
      },
      '&.Mui-focused': {
        backgroundColor: color.surface,
        boxShadow: `0 0 0 0.125rem ${alpha(color.accent, 0.2)}`,
      }
    }
  },
  
  formGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
    gap: 2,
    mt: 2
  },

  select: {
    '& .MuiOutlinedInput-root': {
      borderRadius: radius.md,
      backgroundColor: color.surface,
      '&:hover': {
        backgroundColor: color.mintSoft,
      },
      '&.Mui-focused': {
        backgroundColor: color.surface,
        boxShadow: `0 0 0 0.125rem ${alpha(color.accent, 0.2)}`,
      }
    }
  },

  // Buttons
  submitButton: {
    ...buttonStyles.primary,
    mt: 3,
    mb: 2
  },

  secondaryButton: {
    ...buttonStyles.secondary,
    mt: 2
  },

  dangerButton: {
    color: 'error.main',
    mt: 2,
    '&:hover': {
      backgroundColor: alpha(color.destructive, 0.04),
    }
  },

  // Messages and Alerts
  errorMessage: {
    mt: 2, 
    textAlign: 'center',
    backgroundColor: alpha(color.destructive, 0.1),
    padding: 2,
    borderRadius: radius.sm
  },

  successMessage: {
    mt: 2,
    textAlign: 'center',
    backgroundColor: alpha(color.accent, 0.1),
    padding: 2,
    borderRadius: radius.sm
  },

  // Dialog styles
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: radius.lg,
      padding: 2
    }
  },

  // Google Sign-in button (if we want to style it consistently)
  googleButton: {
    width: '100%',
    mt: 2,
    borderRadius: radius.md,
    border: `0.0625rem solid ${color.line}`,
    padding: '0.625rem 1rem',
    backgroundColor: color.paper,
    '&:hover': {
      backgroundColor: color.surface
    }
  }
}; 